import React from 'react';
import styled from 'styled-components';
import { SystemIcon, Tooltip } from '@utmost.co/utmost-design-system';

type Props = {
  label: string | React.ReactNode;
  tooltipText?: string;
  required?: boolean;
  top?: number;
};

export const InfoText = ({ label, tooltipText, required, top }: Props) => {
  if (!label) {
    return null;
  }

  return (
    <StyledInfoText>
      <span data-test="info-text-label" className="info-label">
        {label}
      </span>
      {tooltipText && (
        <StyledDiv data-test="info-text-tooltip" required={required} top={top}>
          <Tooltip dark title={tooltipText} placement="top">
            <SystemIcon name="info" size={18} />
          </Tooltip>
        </StyledDiv>
      )}
    </StyledInfoText>
  );
};

const StyledInfoText = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
`;

const StyledDiv = styled.div<{ required?: boolean; top?: number }>`
  position: absolute;
  right: ${({ required }) => (required ? '-2rem' : '-1.5rem')};
  top: ${({ top }) => (typeof top === 'number' ? `${top}px` : '-2px')};
`;
